"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Nudge;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Nudge.scss");
var _nudgeIcon = _interopRequireDefault(require("./assets/nudge-icon"));
function Nudge(_ref) {
  var variant = _ref.variant,
    time = _ref.time;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-container-".concat(variant)
  }, variant === "1" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-icon-desktop"
  }, /*#__PURE__*/_react["default"].createElement(_nudgeIcon["default"], {
    variant: variant
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-text-inner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-icon-mobile"
  }, /*#__PURE__*/_react["default"].createElement(_nudgeIcon["default"], {
    variant: variant
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "national-bold"
  }, "Want to rank higher? Reply faster.")), /*#__PURE__*/_react["default"].createElement("div", null, "Reach out to new leads within 15 minutes to get priority placement in our directory."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-links"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "national-bold-blue"
  }, "Give me more tips like this"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "national-medium-blue"
  }, "Dismiss"))), variant === "2" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-icon"
  }, /*#__PURE__*/_react["default"].createElement(_nudgeIcon["default"], {
    variant: variant
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "national-medium"
  }, "Be the first to reach out")), variant === "3" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nudge-icon"
  }, /*#__PURE__*/_react["default"].createElement(_nudgeIcon["default"], {
    variant: variant
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "national-medium"
  }, "Reply by ", time, " for a better chance to win this job!"))));
}
Nudge.propTypes = {
  variant: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['1', '2', '3'])),
  time: _propTypes["default"].string
};
Nudge.defaultProps = {
  variant: '1',
  time: '8:00AM'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Nudge.js
// module id = 2827
// module chunks = 25